import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FiMail, FiCheckCircle } from 'react-icons/fi'
import Swal from 'sweetalert2'
import Loader from '../Loader'
import AuthLayout from '../authLayout/AuthLayout'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3500,
  timerProgressBar: true,
})

// Asks the backend to email a reset link; the link is created and sent server-side
const ForgotPassword = ({ route }) => {
  const [loader, setLoader] = useState(false)
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)

  const requestReset = async () => {
    setLoader(true)
    try {
      const res = await (await fetch(`${route}/api/requestPasswordReset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })).json()
      if (res.status === 'ok') setSent(true)
      else Toast.fire({ icon: 'error', title: res.message || 'Something went wrong. Please try again.' })
    } catch {
      Toast.fire({ icon: 'error', title: 'Something went wrong. Please try again.' })
    } finally {
      setLoader(false)
    }
  }

  if (sent) {
    return (
      <AuthLayout heading="Check your inbox">
        <div className="auth-form">
          <div className="auth-notice">
            <FiCheckCircle size={20} />
            <p>
              If an account exists for <strong>{email}</strong>, we've sent a link to reset your password.
              It expires in 30 minutes. Check your spam folder if you don't see it.
            </p>
          </div>
          <button type="button" className="auth-submit" onClick={() => setSent(false)}>Use a different email</button>
          <p className="auth-switch">Remembered it? <Link to="/login" className="auth-link">Back to sign in</Link></p>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      heading="Forgot your password?"
      subheading="Enter the email on your account and we'll send you a link to choose a new one."
    >
      {loader && <Loader />}
      <form className="auth-form" onSubmit={(e) => { e.preventDefault(); requestReset() }}>
        <div className="auth-field">
          <label htmlFor="email_field">Email</label>
          <div className="auth-input-wrap">
            <span className="auth-input-icon"><FiMail size={17} /></span>
            <input
              id="email_field"
              className="auth-input"
              type="email"
              autoComplete="email"
              placeholder="name@mail.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value.trim().toLowerCase())}
            />
          </div>
        </div>
        <button type="submit" className="auth-submit">Send reset link</button>
        <p className="auth-switch">Remembered it? <Link to="/login" className="auth-link">Back to sign in</Link></p>
      </form>
    </AuthLayout>
  )
}

export default ForgotPassword
